import Textarea from "@mui/joy/Textarea";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { getListUser } from "entities/report_revenue/service";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { FaUpload } from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import AddStudents from "./class.add-students";

const skillsOptions = ["Listening", "Reading", "Writing", "Speaking"];

// 0 = Thứ 2 ... 6 = Chủ nhật (khớp convention course_calendars trong call-group)
const daysOfWeek = [
  "Thứ 2",
  "Thứ 3",
  "Thứ 4",
  "Thứ 5",
  "Thứ 6",
  "Thứ 7",
  "Chủ nhật",
];

const hoursPerSessionOptions = [
  { label: "1 giờ", value: "1" },
  { label: "2 giờ", value: "2" },
];

const cardSx = {
  p: 2,
  bgcolor: "#fff",
  borderRadius: 4,
  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
  mb: 2,
};

const roundedInputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px !important",
    fontSize: 14,
  },
};

const roundedSelectSx = {
  height: 40,
  fontSize: 14,
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "12px",
  },
  "& .MuiSelect-select": {
    padding: "8px 12px",
  },
};

const dropZoneSx = {
  width: "100%",
  minHeight: "170px",
  background: "transparent",
  borderRadius: "12px",
  color: "#555",
  fontWeight: 550,
  border: "1.5px dashed #c4c4c4",
  textTransform: "none",
  flexDirection: "column",
  gap: 1,
  "&:hover": {
    backgroundColor: "rgba(179, 37, 25, 0.04)",
    borderColor: "#B32519",
  },
};

const RequiredLabel = ({ children }) => (
  <Typography variant="body2" mb={0.5} fontWeight={500}>
    {children} <span style={{ color: "#B32519" }}>*</span>
  </Typography>
);

const CreateClass = ({
  onCancel,
  handleImageClickOneOne,
  mediaSrcVideo,
  mediaSrcImage,
  handleFileChangeAndUploadCallVideo,
  showUploadButtonImage,
  showUploadButtonVideo,
  loadingCirImage,
  loadingCirVideo,
  handleFileChangeAndUploadCallOneOne,
  handleSubmit,
  handleChangeCourse,
  formData,
  handleChangeSkills,
}) => {
  useEffect(() => {
    const handleResizeError = (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const overlay = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        const overlayDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );

        if (overlay) {
          overlay.style.display = "none";
        }
        if (overlayDiv) {
          overlayDiv.style.display = "none";
        }
      }
    };

    window.addEventListener("error", handleResizeError);

    return () => {
      window.removeEventListener("error", handleResizeError);
    };
  }, []);

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 224,
        width: 250,
      },
    },
  };

  const selectedDays: number[] = formData.course_days || [];

  const handleToggleDay = (index: number) => {
    const next = selectedDays.includes(index)
      ? selectedDays.filter((d) => d !== index)
      : [...selectedDays, index];
    handleChangeCourse("course_days", next);
  };

  return (
    <Box
      sx={{
        width: "100%",
        margin: "0 auto",
        pb: 2,
      }}
    >
      <Grid container spacing={2}>
        {/* ----- Cột trái ----- */}
        <Grid item xs={12} md={8}>
          {/* Giảng viên + Tiêu đề + Mô tả */}
          <Box sx={cardSx}>
            <SelectTeacher
              handleChangeCourse={handleChangeCourse}
              formData={formData}
            />

            <Stack direction="column" gap={0.5} mt={1}>
              <RequiredLabel>Tiêu đề lớp học</RequiredLabel>
              <TextField
                value={formData.title}
                onChange={(e) => handleChangeCourse("title", e.target.value)}
                name="title"
                fullWidth
                placeholder="Nhập tiêu đề lớp học"
                size="small"
                sx={{ mb: 2, ...roundedInputSx }}
              />
            </Stack>

            <Stack direction="column" gap={0.5}>
              <RequiredLabel>Mô tả lớp học</RequiredLabel>
              <Textarea
                color="neutral"
                value={formData.description}
                onChange={(e) =>
                  handleChangeCourse("description", e.target.value)
                }
                name="description"
                minRows={4}
                placeholder="Nhập mô tả lớp học"
                sx={{
                  borderRadius: "12px",
                  bgcolor: "#fff",
                  fontSize: 14,
                  border: "1px solid #ccc",
                  padding: "8px",
                  "&:focus": { borderColor: "#1976d2" },
                }}
              />
            </Stack>
          </Box>

          {/* Thông tin lớp học */}
          <Box sx={cardSx}>
            <Typography variant="subtitle1" fontWeight={600} mb={2}>
              Thông tin lớp học
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <RequiredLabel>Kiểu khóa học</RequiredLabel>
                <FormControl fullWidth>
                  <Select
                    value={formData.type}
                    onChange={(e) => handleChangeCourse("type", e.target.value)}
                    name="type"
                    displayEmpty
                    fullWidth
                    size="small"
                    sx={roundedSelectSx}
                  >
                    <MenuItem value="Call 1-1">Gọi 1-1</MenuItem>
                    <MenuItem value="Self-learning">Tự học</MenuItem>
                    <MenuItem value="Call group">Gọi nhóm</MenuItem>
                  </Select>
                </FormControl>
                {/* Backend chỉ tạo lớp + lịch + link Google Meet cho kiểu "Call group" */}
                {formData.type !== "Call group" && (
                  <Typography variant="caption" sx={{ color: "#B32519" }}>
                    Chỉ kiểu "Gọi nhóm" mới tạo lớp theo lịch và link Google
                    Meet.
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                <RequiredLabel>Giá khóa học (VND)</RequiredLabel>
                <TextField
                  fullWidth
                  type="number"
                  value={formData.price}
                  onChange={(e) => handleChangeCourse("price", e.target.value)}
                  name="price"
                  placeholder="Nhập giá khóa học"
                  size="small"
                  sx={roundedInputSx}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <RequiredLabel>Kỹ năng</RequiredLabel>
                <FormControl fullWidth>
                  <Select
                    multiple
                    value={formData.skills || []}
                    onChange={handleChangeSkills}
                    input={<OutlinedInput />}
                    displayEmpty
                    renderValue={(selected) => {
                      const items = Array.isArray(selected)
                        ? selected
                        : selected
                        ? [selected]
                        : [];
                      if (items.length === 0) {
                        return (
                          <Typography sx={{ color: "#9e9e9e", fontSize: 14 }}>
                            Chọn kỹ năng
                          </Typography>
                        );
                      }
                      return (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {items.map((value) => (
                            <Chip key={value} size="small" label={value} />
                          ))}
                        </Box>
                      );
                    }}
                    MenuProps={MenuProps}
                    size="small"
                    sx={roundedSelectSx}
                  >
                    {skillsOptions.map((skill) => (
                      <MenuItem key={skill} value={skill}>
                        {skill}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <RequiredLabel>Cấp độ</RequiredLabel>
                <FormControl fullWidth>
                  <Select
                    value={formData.level || ""}
                    onChange={(e) =>
                      handleChangeCourse("level", e.target.value)
                    }
                    name="level"
                    displayEmpty
                    fullWidth
                    size="small"
                    sx={roundedSelectSx}
                  >
                    <MenuItem value="" disabled>
                      Chọn cấp độ
                    </MenuItem>
                    <MenuItem value="band_0_2">0 - 2.0+ IELTS</MenuItem>
                    <MenuItem value="band_2_4">2.0 - 4.0+ IELTS</MenuItem>
                    <MenuItem value="band_4_5">4.0 - 5.0+ IELTS</MenuItem>
                    <MenuItem value="band_5_6">5.0 - 6.0+ IELTS</MenuItem>
                    <MenuItem value="band_6_7">6.0 - 7.0+ IELTS</MenuItem>
                    <MenuItem value="band_7_5">7.5+ IELTS</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* ----- Cột phải: ảnh + video ----- */}
        <Grid item xs={12} md={4}>
          <Box sx={cardSx}>
            <Typography variant="subtitle1" fontWeight={600} mb={2}>
              Hình ảnh giới thiệu lớp học
            </Typography>
            {loadingCirImage ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="170px"
              >
                <CircularProgress />
              </Box>
            ) : mediaSrcImage ? (
              <Box
                sx={{
                  position: "relative",
                  display: "inline-block",
                  width: "100%",
                  "&:hover .hoverText": { opacity: 1 },
                }}
                onClick={handleImageClickOneOne}
              >
                <Typography
                  variant="body2"
                  className="hoverText"
                  sx={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 1,
                    opacity: 0,
                    transition: "opacity 0.3s",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                    color: "#fff",
                    fontWeight: "bold",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    cursor: "pointer",
                    borderRadius: "12px",
                  }}
                >
                  Thay đổi hình ảnh
                </Typography>
                <img
                  src={mediaSrcImage}
                  alt="Media preview"
                  width="100%"
                  style={{ cursor: "pointer", borderRadius: "12px" }}
                />
              </Box>
            ) : (
              showUploadButtonImage && (
                <Button component="label" sx={dropZoneSx}>
                  <FaUpload size={22} />
                  <Typography fontWeight={700}>TẢI ẢNH</Typography>
                  <Typography variant="body2" sx={{ color: "#777" }}>
                    Chọn hoặc kéo thả ảnh vào đây
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#999" }}>
                    (JPG, PNG, tối đa 5MB)
                  </Typography>
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleFileChangeAndUploadCallOneOne}
                  />
                </Button>
              )
            )}
          </Box>

          <Box sx={cardSx}>
            <Typography variant="subtitle1" fontWeight={600} mb={2}>
              Video giới thiệu lớp học
            </Typography>
            {loadingCirVideo ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="170px"
              >
                <CircularProgress />
              </Box>
            ) : mediaSrcVideo ? (
              <>
                <video
                  src={mediaSrcVideo}
                  controls
                  width="100%"
                  style={{ borderRadius: "12px" }}
                ></video>
                <Button
                  component="label"
                  variant="contained"
                  color="secondary"
                  sx={{ width: "100%", mt: 1, textTransform: "none" }}
                >
                  Thay đổi video
                  <input
                    type="file"
                    accept="video/mp4"
                    style={{ display: "none" }}
                    onChange={handleFileChangeAndUploadCallVideo}
                  />
                </Button>
              </>
            ) : (
              showUploadButtonVideo && (
                <Button component="label" sx={dropZoneSx}>
                  <FaUpload size={22} />
                  <Typography fontWeight={700}>TẢI VIDEO</Typography>
                  <Typography variant="body2" sx={{ color: "#777" }}>
                    Chọn hoặc kéo thả video vào đây
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#999" }}>
                    (MP4, tối đa 100MB)
                  </Typography>
                  <input
                    type="file"
                    accept="video/mp4"
                    style={{ display: "none" }}
                    onChange={handleFileChangeAndUploadCallVideo}
                  />
                </Button>
              )
            )}
          </Box>
        </Grid>

        {/* ----- Lịch học (full width) ----- */}
        <Grid item xs={12}>
          <Box sx={cardSx}>
            <Typography variant="subtitle1" fontWeight={600} mb={2}>
              Lịch học
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={7}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <RequiredLabel>Số lượng người tham gia</RequiredLabel>
                    <TextField
                      fullWidth
                      type="number"
                      value={formData.limit_member ?? ""}
                      onChange={(e) =>
                        handleChangeCourse("limit_member", e.target.value)
                      }
                      name="limit_member"
                      placeholder="Nhập số lượng"
                      size="small"
                      sx={roundedInputSx}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <RequiredLabel>Số giờ học/buổi</RequiredLabel>
                    <FormControl fullWidth size="small">
                      <Select
                        value={formData.class_duration || ""}
                        onChange={(e) =>
                          handleChangeCourse("class_duration", e.target.value)
                        }
                        name="class_duration"
                        displayEmpty
                        fullWidth
                        size="small"
                        sx={roundedSelectSx}
                      >
                        <MenuItem value="" disabled>
                          Chọn số giờ
                        </MenuItem>
                        {hoursPerSessionOptions.map((opt) => (
                          <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <RequiredLabel>Khung giờ dạy</RequiredLabel>
                    <input
                      type="time"
                      name="time_slot"
                      value={formData.time_slot || ""}
                      onChange={(e) =>
                        handleChangeCourse("time_slot", e.target.value)
                      }
                      style={{
                        width: "100%",
                        padding: "8px 10px",
                        borderRadius: "12px",
                        border: "1px solid #ccc",
                        fontSize: 14,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <RequiredLabel>Thời gian lớp học</RequiredLabel>
                    <Stack direction="row" alignItems="center" gap={1}>
                      <input
                        type="date"
                        name="start_time"
                        value={formData.start_time || ""}
                        onChange={(e) =>
                          handleChangeCourse("start_time", e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "8px 10px",
                          borderRadius: "12px",
                          border: "1px solid #ccc",
                          fontSize: 14,
                        }}
                      />
                      <span>-</span>
                      <input
                        type="date"
                        name="end_time"
                        value={formData.end_time || ""}
                        onChange={(e) =>
                          handleChangeCourse("end_time", e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "8px 10px",
                          borderRadius: "12px",
                          border: "1px solid #ccc",
                          fontSize: 14,
                        }}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={5}>
                <RequiredLabel>Chọn ngày dạy</RequiredLabel>
                <Grid container>
                  {daysOfWeek.map((label, index) => (
                    <Grid item xs={6} key={label}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={selectedDays.includes(index)}
                            onChange={() => handleToggleDay(index)}
                            sx={{
                              color: "#B32519",
                              "&.Mui-checked": { color: "#B32519" },
                            }}
                          />
                        }
                        label={
                          <Typography variant="body2">{label}</Typography>
                        }
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* ----- Học sinh (full width) ----- */}
        <Grid item xs={12}>
          <AddStudents
            formData={formData}
            handleChangeCourse={handleChangeCourse}
          />
        </Grid>
      </Grid>

      {/* ----- Hành động ----- */}
      <Stack direction="row" justifyContent="flex-end" gap={1.5} mt={1} pb={6}>
        {onCancel && (
          <Button
            variant="outlined"
            onClick={onCancel}
            sx={{
              textTransform: "none",
              color: "#555",
              borderColor: "#ccc",
              "&:hover": { borderColor: "#999" },
            }}
          >
            Hủy
          </Button>
        )}
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            bgcolor: "#B32519 !important",
            textTransform: "none",
            "&:hover": { bgcolor: "#B32519 !important" },
          }}
        >
          Tạo lớp học
        </Button>
      </Stack>
    </Box>
  );
};

const SelectTeacher = ({ handleChangeCourse, formData }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [teachers, setTeachers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [pendingTeacher, setPendingTeacher] = useState<any>(null);
  const observer = useRef<IntersectionObserver | null>(null);

  const selectedTeachers: any[] = formData.teachers || [];
  const MAX_TEACHERS = 4;

  const fetchTeachers = async (search = "", newPage = 1) => {
    if (loading || (!hasMore && newPage !== 1)) return;

    setLoading(true);
    try {
      const response = await getListUser({
        limit: 10,
        page: newPage,
        user_role: "teacher",
        search,
      });

      const newTeachers = response.data || [];

      if (newPage === 1) {
        setTeachers(newTeachers);
      } else {
        setTeachers((prev) => [...prev, ...newTeachers]);
      }

      setHasMore(newTeachers.length >= 10);
    } catch (error) {
      console.error("Lỗi khi lấy danh sách giáo viên:", error);
    }
    setLoading(false);
  };

  const lastTeacherRef = useCallback(
    (node) => {
      if (loading || !hasMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useEffect(() => {
    fetchTeachers(searchTerm, page);
  }, [page]);

  useEffect(() => {
    setPage(1);
    fetchTeachers(searchTerm, 1);
  }, [searchTerm]);

  const handleAddTeacher = () => {
    if (!pendingTeacher) return;
    if (selectedTeachers.length >= MAX_TEACHERS) return;
    if (selectedTeachers.some((t) => t._id === pendingTeacher._id)) return;

    handleChangeCourse("teachers", [...selectedTeachers, pendingTeacher]);
    setPendingTeacher(null);
    setSearchTerm("");
  };

  const handleRemoveTeacher = (id: string) => {
    handleChangeCourse(
      "teachers",
      selectedTeachers.filter((t) => t._id !== id)
    );
  };

  const availableOptions = teachers.filter(
    (t) => !selectedTeachers.some((s) => s._id === t._id)
  );
  const reachedMax = selectedTeachers.length >= MAX_TEACHERS;

  return (
    <Box flex={1} mb={1}>
      <Typography variant="body2" mb={0.5} fontWeight={500}>
        Giảng viên{" "}
        <span style={{ color: "#888", fontWeight: 400 }}>
          (tối đa {MAX_TEACHERS} giảng viên)
        </span>
      </Typography>
      <Stack direction="row" gap={1} alignItems="stretch">
        <Autocomplete
          sx={{ flex: 1 }}
          value={pendingTeacher}
          onChange={(event, newValue) => setPendingTeacher(newValue)}
          inputValue={searchTerm}
          onInputChange={(event, newInputValue) =>
            setSearchTerm(newInputValue)
          }
          options={availableOptions}
          getOptionLabel={(option) => option.display_name || ""}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          loading={loading}
          disabled={reachedMax}
          renderOption={(props, option, { index }) => (
            <li
              {...props}
              key={option._id}
              ref={index === availableOptions.length - 1 ? lastTeacherRef : null}
            >
              {option.display_name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              size="small"
              placeholder="Chọn giảng viên"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              sx={roundedInputSx}
            />
          )}
        />
        <Button
          variant="outlined"
          startIcon={<FiPlus />}
          onClick={handleAddTeacher}
          disabled={!pendingTeacher || reachedMax}
          sx={{
            textTransform: "none",
            whiteSpace: "nowrap",
            borderRadius: "12px",
            color: "#B32519",
            borderColor: "#B32519",
            "&:hover": { borderColor: "#B32519", bgcolor: "rgba(179,37,25,0.04)" },
          }}
        >
          Thêm
        </Button>
      </Stack>

      {selectedTeachers.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1.5 }}>
          {selectedTeachers.map((t) => (
            <Chip
              key={t._id}
              label={t.display_name}
              onDelete={() => handleRemoveTeacher(t._id)}
              sx={{ bgcolor: "#f0f0f0", borderRadius: "16px" }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CreateClass;
